import { Expose, plainToInstance } from "class-transformer";
import camelcaseKeys from "camelcase-keys";

export class SellSummeryReportModel {
  @Expose()
  public date?: string;

  @Expose()
  public totalAmount?: number;

  public static toClass(data: object) {
    //@ts-ignore
    return plainToInstance(SellSummeryReportModel, camelcaseKeys(data, { deep: true }), { excludeExtraneousValues: true });
  }

  public static toArrayOfClass(data: object[]) {
    //@ts-ignore
    return plainToInstance(SellSummeryReportModel, camelcaseKeys(data, { deep: true }) as SellSummeryReportModel[], { excludeExtraneousValues: true });
  }
}
